<template>
    <div class="login-wrap">
        <div class="login-logo">
            <img src="@/images/temporary/logo.png" alt="logo">
        </div>
        <div class="login-bg">
            <div class="login-area">
                <div class="login-form" v-if="!willRegister">
                    <h3 class="form-title">{{$t('titleName0')}}</h3>
                    <div class="form-tabs">
                        <div :class="['login-method', {'login-method-select':loginMethod==0}]" @click="changeLoginMethod(0)">{{$t('loginMethod0')}}</div>
                        <div :class="['login-method', {'login-method-select':loginMethod==1}]" @click="changeLoginMethod(1)">{{$t('loginMethod1')}}</div>
                    </div>
                    <div v-if="loginMethod==0">
                        <div class="form-item">
                            <Input prefix="ios-contact-outline" size="large" :placeholder="$t('account')" v-model="account"/>
                        </div>
                        <div class="form-item">
                            <Input prefix="ios-lock-outline" size="large" v-model="password" :placeholder="$t('password')" type="password"/>
                        </div>
                        <div class="form-item form-right">
                            <RadioGroup v-model="lang" @on-change="changeLang">
                                <Radio label="en-us">English</Radio>
                                <Radio label="zh-cn">中文</Radio>
                            </RadioGroup>
                        </div>
                        <Button type="primary" size="large" @click="doLogin" long>{{$t('login')}}</Button>
                    </div>
                    <div v-else>
                        <div class="form-item">
                            <Input prefix="ios-call-outline" size="large" :placeholder="$t('phoneNumber')" v-model="phoneNumber"/>
                        </div>
                        <div class="form-item form-code">
                            <Input size="large" prefix="ios-mail-outline" v-model="verification" :placeholder="$t('verificationCode')" style="margin-right:10px"/>
                            <Button type="primary" @click="getVCode" ghost v-if="btnCodeCanClick">{{$t('getVCode')}}</Button>
                            <Button type="primary" ghost v-else disabled>{{`${$t('send')}(${remainingTime}s)`}}</Button>
                        </div>
                        <div class="form-item form-right">
                            <RadioGroup v-model="lang" @on-change="changeLang">
                                <Radio label="en-us">English</Radio>
                                <Radio label="zh-cn">中文</Radio>
                            </RadioGroup>
                        </div>
                        <Button type="primary" size="large" @click="doLoginPhone" long>{{$t('login')}}</Button>
                    </div>
                    <div class="login-select">
                        <span>{{$t('a_noAccount')}}&nbsp;</span>
                        <span class="login-register" @click="toRegister">{{$t('a_registerNow')}}</span>
                    </div>
                </div>
                <div class="login-form" v-else>
                    <h3 class="form-title">{{$t('titleName1')}}</h3>
                    <div class="form-item">
                        <Input prefix="ios-call-outline" size="large" :placeholder="$t('phoneNumber')" v-model="phoneNumber"/>
                    </div>
                    <div class="form-item">
                        <Captcha :captchaConfig="captchaConfig" @eventCaptcha="eventCaptcha"></Captcha>
                    </div>
                    <div class="form-item form-code">
                        <Input size="large" prefix="ios-mail-outline" v-model="verification" :placeholder="$t('verificationCode')" style="margin-right:10px"/>
                        <Button type="primary" @click="getVCodeRegister" ghost v-if="btnCodeCanClick">{{$t('getVCode')}}</Button>
                        <Button type="primary" ghost v-else disabled>{{`${$t('send')}(${remainingTime}s)`}}</Button>
                    </div>
                    <div class="form-item">
                        <Input prefix="ios-lock-outline" size="large" v-model="password" :placeholder="$t('password')" type="password"/>
                    </div>
                    <Button type="primary" size="large" @click="doRegister" long>{{$t('register')}}</Button>
                    <div class="form-protocol">
                        {{$t('a_protocol1')}}
                        <a href="javascript:;" style="color: #07aa9b;">{{$t('a_protocol2')}}</a>
                    </div>
                    <div class="login-select">
                        <span>{{$t('a_hadAccount')}}&nbsp;</span>
                        <span class="login-register" @click="toLogin">{{$t('a_loginNow')}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-footer">
            <p>Copyright ©</p>
            <p>{{$t('companyName')}}</p>
            <p>{{$t('icp')}}</p>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Captcha from './components/Captcha';

export default {
    data() {
        return {
            account: '',
            password: '',
            lang: this.$i18n.locale,
            loginMethod: 0, //0：账号登录  1：密码登录
            phoneNumber: '',
            verification: '', //验证码
            btnCodeCanClick: true, //获取验证码的按钮是否可以点击
            Timer1: '', //定时器
            remainingTime: 60, //剩余时间
            willRegister: false, //是否注册
            validateSuccess: 0, //滑块验证是否成功
            captchaConfig: {
                width: 330,
                height: 36
            }
        };
    },
    created() {
        this.keydownEnter(); //添加回车事件
    },
    beforeDestroy() {
        document.onkeydown = null;
    },
    methods: {
        keydownEnter() {
            document.onkeydown = e => {
                if (e.keyCode === 13 && e.target.baseURI.includes('login') && !this.willRegister) {
                    if (this.loginMethod == 0) {
                        this.doLogin();
                    } else {
                        this.doLoginPhone();
                    }
                }
            };
        },
        doLogin() {
            // 判断账户
            if (this.account == '' || this.password == '') {
                this.$Message.error(this.$t('loginEmpty'));
                return;
            }
            // 开始登陆
            this.$Loading.start();
            Axios.get(AxiosUrl.user.login, {
                params: {
                    account: this.account,
                    password: this.password
                }
            }).then(res => {
                if (res.data.code == 200) {
                    // 验证通过
                    // 将用户信息写入localstorage
                    sessionStorage.setItem('user', JSON.stringify(res.data.data)); // json序列化存储用户登录信息
                    sessionStorage.setItem('time', new Date().getTime() / 1000);
                    this.$store.commit('upUser', res.data.data);
                    if (res.data.data.cid == 0) {
                        this.$router.replace({ path: `/qrcode/${res.data.data.uid}` });
                    } else {
                        // 跳转到home
                        this.$router.push('home');
                    }
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
            this.$Loading.finish();
        },
        doLoginPhone() {
            // 判断账户
            if (this.phoneNumber == '' || this.verification == '') {
                this.$Message.error(this.$t('loginEmpty3'));
                return;
            }
            if (!/^1[345678]\d{9}$/.test(this.phoneNumber)) {
                this.$Message.error(this.$t('loginEmpty2'));
                return;
            }
            this.$Loading.start();
            Axios.get(AxiosUrl.user.captchalogin, {
                params: {
                    phone: this.phoneNumber,
                    captcha: this.verification
                }
            }).then(res => {
                if (res.data.code == 200) {
                    // 验证通过
                    // 将用户信息写入localstorage
                    sessionStorage.setItem('user', JSON.stringify(res.data.data)); // json序列化存储用户登录信息
                    sessionStorage.setItem('time', new Date().getTime() / 1000);
                    this.$store.commit('upUser', res.data.data);
                    if (res.data.data.cid == 0) {
                        this.$router.replace({ path: `/qrcode/${res.data.data.uid}` });
                    } else {
                        // 跳转到home
                        this.$router.push('home');
                    }
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
            this.$Loading.finish();
        },
        doRegister() {
            // 判断账户
            if (this.phoneNumber == '' || this.password == '' || this.verification == '') {
                this.$Message.error(this.$t('loginEmpty5'));
                return;
            }
            Axios.get(AxiosUrl.user.register, {
                params: {
                    phone: this.phoneNumber,
                    password: this.password,
                    captcha: this.verification
                }
            }).then(res => {
                if (res.data.code == 200) {
                    sessionStorage.setItem('user', JSON.stringify(res.data.data)); // json序列化存储用户登录信息
                    sessionStorage.setItem('time', new Date().getTime() / 1000);
                    this.$store.commit('upUser', res.data.data);
                    // 跳转到扫二维码界面
                    this.$router.replace({ path: `/qrcode/${res.data.data.uid}` });
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        //获取验证码
        getVCode() {
            // 判断手机号
            if (this.phoneNumber == '') {
                this.$Message.error(this.$t('loginEmpty1'));
                return;
            }
            if (!/^1[345678]\d{9}$/.test(this.phoneNumber)) {
                this.$Message.error(this.$t('loginEmpty2'));
                return;
            }
            Axios.get(AxiosUrl.sms.captcha, {
                params: {
                    phone: this.phoneNumber,
                    action: 'login'
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('a_smsSended'));
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
            this.btnCodeCanClick = false;
            this.Timer1 = setInterval(() => {
                if (this.remainingTime != 0) {
                    this.remainingTime--;
                } else {
                    clearInterval(this.Timer1);
                    this.remainingTime = 60;
                    this.btnCodeCanClick = true;
                }
            }, 1000);
        },
        //注册界面获取验证码
        getVCodeRegister() {
            // 判断手机号
            if (this.phoneNumber == '') {
                this.$Message.error(this.$t('loginEmpty1'));
                return;
            }
            if (!/^1[345678]\d{9}$/.test(this.phoneNumber)) {
                this.$Message.error(this.$t('loginEmpty2'));
                return;
            }
            //判断是否通过验证
            if (this.validateSuccess == 0) {
                this.$Message.error(this.$t('loginEmpty4'));
                return;
            }
            Axios.get(AxiosUrl.sms.captcha, {
                params: {
                    phone: this.phoneNumber,
                    action: 'register'
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('a_smsSended'));
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
            this.btnCodeCanClick = false;
            this.Timer1 = setInterval(() => {
                if (this.remainingTime != 0) {
                    this.remainingTime--;
                } else {
                    clearInterval(this.Timer1);
                    this.remainingTime = 60;
                    this.btnCodeCanClick = true;
                }
            }, 1000);
        },
        changeLang(value) {
            this.$i18n.locale = value;
            sessionStorage.setItem('lang', value);
        },
        changeLoginMethod(val) {
            this.loginMethod = val;
            this.remainingTime = 60;
            clearInterval(this.Timer1);
            this.btnCodeCanClick = true;
        },
        toRegister() {
            this.btnCodeCanClick = true;
            this.password = '';
            this.phoneNumber = '';
            this.verification = '';
            this.remainingTime = 60;
            clearInterval(this.Timer1);
            this.willRegister = true;
        },
        toLogin() {
            this.password = '';
            this.phoneNumber = '';
            this.verification = '';
            this.remainingTime = 60;
            clearInterval(this.Timer1);
            this.btnCodeCanClick = true;
            this.willRegister = false;
        },
        eventCaptcha(value) {
            this.validateSuccess = value;
        }
    },
    components: { Captcha }
};
</script>
<style lang="less">
.login-wrap {
    position: relative;
    height: 100%;
}
.login-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-color: #009dd0;
    background-image: -webkit-linear-gradient(left, #07aa9b, #009dd0);
    background-image: linear-gradient(to right, #07aa9b, #009dd0);
    background-repeat: no-repeat;
}
.login-area {
    margin-top: -100px;
    box-shadow: 1px 2px 15px rgba(0, 0, 0, 0.1);
}
.login-logo {
    position: absolute;
    top: 45px;
    left: 50px;
    width: 250px;
}
.login-form {
    width: 400px;
    padding: 35px;
    background-color: white;
    box-shadow: 0 0 8px #666;
    border-radius: 3px;
    .form-title {
        text-align: center;
        color: #07aa9b;
        font-size: 26px;
        font-weight: 400;
        padding-bottom: 15px;
    }
    .form-item {
        margin-bottom: 15px;
    }
    .form-protocol {
        text-align: center;
        padding-top: 5px;
    }
    .form-right {
        display: flex;
        justify-content: flex-end;
    }
    .form-code {
        display: flex;
    }
    .form-tabs {
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #dcdee2;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        margin-bottom: 15px;
        .login-method {
            cursor: pointer;
        }
        .login-method-select {
            font-size: 16px;
            color: #07aa9b;
            border-bottom: 2px solid #07aa9b;
            margin-bottom: -1px;
        }
    }
}
.login-select {
    padding-top: 15px;
    display: flex;
    justify-content: flex-end;
    .login-register {
        color: #07aa9b;
    }
    .login-register:hover {
        cursor: pointer;
    }
}
.login-footer {
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    p {
        color: white;
        font-size: 14px;
        padding-left: 26px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/login/login.vue